module.exports = {
	"galleries": [
		{
			"title": "Blal bbb",
			"images": [
				"../img/gallery/img_2.jpg",
				"../img/gallery/img_3.jpg",
				"../img/gallery/img_4.jpg"
			]
		}
	],
	"selectedImage": null
};


//////////////////
// WEBPACK FOOTER
// ./src/data/initialState.json
// module id = 324
// module chunks = 0